import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderContentComponent } from './header-content.component';

@NgModule({
  declarations: [HeaderContentComponent],
  imports: [CommonModule],
  exports: [HeaderContentComponent],
})
export class HeaderContentModule {}
